import { mergeStrings } from "../../order/utils/orderHelpers"
import { checkPermissions, getAssignedCustomers } from "../../shared/permissions/permissions"
import { DomainObjects, Operations } from "../../shared/permissions/permissionsConfig"

export const queryAllAnniversaries = {
  async allAnniversaries(_parent, _args, context, _info) {
    const { user } = context

    await checkPermissions({
      user,
      domainObject: DomainObjects.CUSTOMERS,
      operation: Operations.READ,
    })

    const customers = await getAssignedCustomers({
      admNumber: user?.loggedInAdm?.admNumber,
    })

    const customersData = []

    customers?.map(({ id, customerNumber, companyName, custom, addresses }) => {
      const birthday = addresses?.map(({ firstName, lastName, custom }) => {
        return {
          customerId: id,
          customerNumber,
          name: mergeStrings([firstName, lastName]),
          date: custom?.fields?.dateOfBirth || "",
          type: "birthday",
        }
      })

      return customersData.push(...birthday, {
        customerId: id,
        customerNumber,
        name: companyName,
        date: custom?.fields?.foundingDate || "",
        type: "founding",
      })
    })

    if (!customersData || customersData.length === 0)
      return {
        items: [],
        page: 0,
        total: 0,
        totalPages: 0,
      }

    return {
      items: customersData,
      page: 0,
      total: customersData?.length,
      totalPages: 1,
    }
  },
}
